import {
  RequestModel,
  requestModel,
} from '@/app/request/RequestModel';
import { useUserStore } from '@/shared/store/useUserStore';
import { useBitrixStore } from '@/shared/store/useBitrixStore';

export function bitrixKeepSyncBitrixId(updateRequest: RequestModel) {
  const userStore = useUserStore();
  const bitrixStore = useBitrixStore();
  const { bitrixId } = userStore;
  const bitrixBitrixId = Number(bitrixStore.bitrixId);

  if (bitrixId && bitrixBitrixId !== bitrixId) {
    updateRequest = requestModel(updateRequest, {
      body: {
        ...updateRequest.body,
        bitrix_id: bitrixId,
      },
    });
    bitrixStore.setBitrixId(String(bitrixId));
  }

  return updateRequest;
}
